import { isRouteErrorResponse } from 'react-router';

import { ApiError } from '@/shared/api/http/client';

export type ErrorKind = 'network' | 'notFound' | 'service' | 'unexpected';

export type ErrorPresentation = {
  readonly kind: ErrorKind;
  readonly message: string | null;
  readonly status: number | null;
  readonly code: string | null;
  readonly correlationId: string | null;
};

function presentText(value: string | null | undefined): string | null {
  const text = value?.trim();
  return text ? text : null;
}

function kindForStatus(status: number): ErrorKind {
  if (status === 404) return 'notFound';
  if (status >= 500) return 'service';
  return 'unexpected';
}

export function errorPresentation(error: unknown): ErrorPresentation {
  if (error instanceof ApiError) {
    return {
      kind:
        error.status === 0 || error.code === 'networkUnavailable'
          ? 'network'
          : kindForStatus(error.status),
      message: presentText(error.message),
      status: error.status === 0 ? null : error.status,
      code: presentText(error.code),
      correlationId: presentText(error.correlationId),
    };
  }

  if (isRouteErrorResponse(error)) {
    return {
      kind: kindForStatus(error.status),
      message: presentText(error.statusText),
      status: error.status,
      code: null,
      correlationId: null,
    };
  }

  if (error instanceof Error) {
    return {
      kind: 'unexpected',
      message: presentText(error.message),
      status: null,
      code: null,
      correlationId: null,
    };
  }

  return {
    kind: 'unexpected',
    message: null,
    status: null,
    code: null,
    correlationId: null,
  };
}
